import { useAppDisplayModeContext } from '@archipro-design/aria';
import Heading from './Heading';
import Content from './Content';
import type { ProductPageLoaderData } from '~/routes/_app.product.$urlSegment';

interface AboutSellerProps {
    data: ProductPageLoaderData['product'];
}

const AboutSeller = ({ data }: AboutSellerProps) => {
    const { mobile } = useAppDisplayModeContext();

    return (
        <div style={{ display: mobile ? 'none' : 'block' }}>
            <Heading data={data.Professional} />
            <Content data={data.Professional} />
        </div>
    );
};

export default AboutSeller;
